<style scoped lang="scss">

</style>

<template>
    <div>
        <fieldset class="agreement-container">
            <legend class="agreement-title">
                Tenant Certification
            </legend>


            <div class="uk-grid">
                <div class="uk-width-1-1">
                    <div class="uk-block uk-block-default">
                        <p align="justify">I attest that the information included in and with this application is correct and complete.</p>
                        <p align="justify">I attest that the property for which I am applying for assistance is my primary residence.</p>
                        <p align="justify">I attest that my application for KERA benefits does not duplicate any other federally funded assistance provided to me or other adults in my household for the costs requested here and agree to repay any awarded KERA assistance that was duplicated.</p>
                        <p align="justify">I understand I am still responsible for additional unpaid rent and are still subject to eviction for any such amounts. I also understand that I am responsible for any other responsibilities and obligations outlined in my lease. If I have questions about my lease or my rights in an eviction, I should consult a lawyer.</p>
                        <p align="justify">I attest that I have not been disqualified for LIEAP, SNAP, TANF or other State or Federal funding due to fraud.</p>
                        <p align="justify">I consent to contact regarding this application at the phone number or email address provided by me.</p>
                        <p align="justify">I agree to fully cooperate with KHRC on any reasonable verification or compliance follow up request.</p>
                        <p align="justify">I understand that submission of an application does not guarantee that I am eligible for benefits or assistance and that other factors may be considered in reviewing my application. Further, I understand that KERA funds will not be disbursed until it has been determined that I am eligible to participate and all proper certifications and required documents have been submitted to KHRC.</p>
                        <p align="justify">I understand and agree that I may be required to repay KERA funds to KHRC if I am later found to be ineligible or provide false, misleading or incomplete information.</p>
                        <p align="justify">I understand I may be subject to civil and criminal penalties if I knowingly provide false or misleading information related to this application. I further understand that it is a criminal violation under Kansas law to make a false statement in writing for the purpose of procuring assistance from a state agency.</p>
                        <p align="justify">I attest that I have been given the opportunity to review KHRC’s Privacy Policy, Terms of Use and Disclaimer and I agree to the terms and conditions contained in each of those documents.</p>
                        <p align="justify">I understand this is a LEGALLY BINDING DOCUMENT.</p>
                        <p align="justify">Limitation of Liability and Indemnification. By using this Site, you agree to DEFEND, INDEMNIFY, RELEASE AND HOLD HARMLESS THE STATE OF KANSAS, KHRC, ITS OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS AND AGENTS (THE “RELEASED PARTIES”) FROM ANY AND ALL CLAIMS, ACTIONS, SUITS AND DEMANDS THAT RELATE TO OR ARISE OUT OF: (1) YOUR KERA APPLICATION; (2) ANY ACTION OR INACTION TAKEN BY THE RELEASED PARTIES IN THE ADMINISTRATION AND MANAGEMENT OF KERA; (3) USE OR INABILITY TO USE THIS SITE OR INFORMATION AVAILABLE FROM THIS SITE; (4) LOSS OF DATA OR COMPUTER EQUIPMENT RESULTING FROM THE SITE OR THE DOWNLOAD OF ANY INFORMATION OR CONTENT FROM THIS SITE; (5) TRANSACTIONS OR CONTACT BETWEEN YOU AND THIRD PARTIES LINKED TO THIS SITE; (6) FOR ANY VIOLATION BY YOU OF THE TERMS OF USE AGREEMENT OR PRIVACY POLICY; AND (7) CLAIMS, ACTIONS, SUITS AND DEMANDS BROUGHT BY OTHER PERSONS OR ENTITIES ARISING FROM OR RELATED TO YOUR USE OF THIS SITE OR INFORMATION OBTAINED FROM THIS SITE. IN NO EVENT SHALL THE RELEASED PARTIES BE LIABLE OR RESPONSIBLE FOR ANY LOSS, DIRECT, INDIRECT, PUNITIVE, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGE (INCLUDING BUT NOT LIMITED TO LOSS OF BUSINESS, REVENUE, PROFITS, USE, DATA OR OTHER ECONOMIC ADVANTAGE), ATTORNEYS’ FEES, EXPENSES OR COSTS IN THE EVENT OF SUCH CLAIMS, ACTIONS, SUITS AND DEMANDS.</p>
                    </div>
                </div>
            </div>

            <div class="uk-width-1-1 uk-grid uk-margin-large-bottom" v-if="application.household">
                <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                    <div v-if="member.age >= 18">
                        <div class="uk-width-medium-1-1">

                            <legend>{{ member.first_name }} {{ member.last_name }}</legend>

                            <validated-section :errors="errors" :field="'signature_'+member.id">
                                <signature-box @updated="onSignatureUpdated"
                                               :user-key="member.id"
                                               :is-signed="signatureData[member.id] && signatureData[member.id].disclaimer_signed_at"
                                               :completed="signatureData[member.id] && signatureData[member.id].completed"
                                               :name="member.first_name + ' ' + member.last_name"
                                               :color="programSettings['primary-program-color']"
                                               ref="signatureBox"
                                ></signature-box>
                            </validated-section>

                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    export default {
        name: "Step6",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                signatures: {},
                errors: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-terms-conditions`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, {
                                disclaimer_signed_at: signatureFiltered.created_at,
                                disclaimer_conviction_checked_at: signatureFiltered.created_at,
                                disclaimer_background_checks_checked_at: signatureFiltered.created_at,
                                completed: true,
                            })
                        }
                    }
                })
            },
            onCheckboxUpdated(memberId, field, checked) {
                if(!this.signatureData[memberId]) {
                    this.$set(this.signatureData, memberId, {});
                }
                this.$set(this.signatureData[memberId], field, checked ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'disclaimer_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {
                this.errors = {};

                //Local Validation
                _.each(this.application.household.members, (member) => {
                   if(member.age >= 18) {
                        if(!this.signatureData[member.id] || !this.signatureData[member.id].disclaimer_signed_at) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                   }
                })

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-6`, data)
            }
        }
    }
</script>
